






import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({
	name: 'FreemiumIcon',
})
export default class FreemiumIcon extends Vue {
	@Prop({
		default: 'md',
		validator: (value: string): boolean => {
			return ['sm', 'md', 'lg', 'xl'].includes(value);
		},
	})
	size: string;

	get classNames() {
		return {
			'freemium-icon': true,
			[`freemium-icon--${this.size}`]: this.size,
		};
	}

	get iconSize() {
		return this.size === 'lg' ? '2x' : 'lg';
	}
}
